import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const ReceiptCustomization = yup.object().shape({
  title: yup.string(),
  description: yup.string(),
});

const useValidation = (details) => {
  return useForm({
    resolver: yupResolver(ReceiptCustomization),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      title: details?.title,
      description: details?.description,
    },
  });
};

export default useValidation;
